import { gql } from "@apollo/client";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import { isAuthenticated, logicaErrorBody } from "./helper";
import ChatGuideLineAgreement from "@/lib/chatGuideLineAgreement";
import { GraphQLError } from "graphql";
export const typeDef = gql`
  type ChatGuidelineAgreement @cacheControl(scope: PRIVATE, maxAge: 0) {
    agreement: Boolean
  }

  type ChatRoomConfig {
    messageLimit: Int
    pollingInterval: Int
    initialMessageLimit: Int
    userLimit: Int
  }

  type ChatRoomCustomData {
    type: String
    liveStartBefore: Int
    liveEndAfter: Int
    skipMessageThreshold: Int
    appMessageLimit: Int
  }

  type ChatRoom {
    roomId: String
    config: ChatRoomConfig
    customData: ChatRoomCustomData
  }

  type ChatRooms @cacheControl(scope: PRIVATE) {
    totalCount: Int
    rooms: [ChatRoom]
  }

  type Token @cacheControl(scope: PRIVATE) {
    token: String
  }

  type ChatUser {
    roomId: String
    refId: String
    id: String
  }

  type Sender {
    displayName: String
    refId: String
    id: String
  }

  type ChatMessage {
    message: String
    sender: Sender
    roomId: String
    isNGMessage: Boolean
    id: String
  }

  type MessageResult {
    result: Boolean
  }

  type Query {
    getChatGuideLineAgreement: ChatGuidelineAgreement
    getRooms(metaId: Int): ChatRooms
    getRoomToken(roomId: String): Token
    getUserToken(roomId: String, userId: String): Token
  }

  type Mutation {
    setChatGuideLineAgreement: ChatGuidelineAgreement
    createUser(roomId: String, metaId: Int): ChatUser
    postChatMessage(
      roomId: String
      userId: String
      message: String
      refId: String
      displayName: String
      token: String
    ): ChatMessage
    deleteChatMessage(roomId: String, messageId: String): MessageResult
    reportChatMessage(
      roomId: String
      messageId: String
      reason: String
    ): MessageResult
  }
`;
export const resolvers = composeResolvers({
  Query: {
    getChatGuideLineAgreement: async (_parent, _ref, _ref2) => {
      let {} = _ref;
      let {
        req,
        res,
        dataSources
      } = _ref2;
      try {
        console.log("get cookie");
        const agreement = new ChatGuideLineAgreement(req, res);
        const cookie = await agreement.getCookie();
        console.log(cookie);
        return {
          agreement: !!cookie,
          nickName: cookie
        };
      } catch (e) {
        console.log("getChatGuideLineAgreement error", e);
        // console.log(JSON.stringify(e.extentions, null, 2));
      }
    },

    getRooms: async (_parent, _ref3, _ref4) => {
      let {
        metaId
      } = _ref3;
      let {
        dataSources
      } = _ref4;
      try {
        const res = await dataSources.meta.getRooms(metaId);
        console.log("res.meta_rooms", res.meta_rooms);
        // Fisher-Yatesアルゴリズム
        const shuffleArray = arr => {
          var i, j, temp;
          arr = arr.slice();
          i = arr.length;
          if (i === 0) {
            return arr;
          }
          while (--i) {
            j = Math.floor(Math.random() * (i + 1));
            temp = arr[i];
            arr[i] = arr[j];
            arr[j] = temp;
          }
          return arr;
        };
        const shuffledRooms = shuffleArray(res.meta_rooms);
        console.log("shuffledRooms", shuffledRooms);
        const rooms = shuffledRooms.map(room => {
          var _room$config, _room$config2, _room$config3, _room$config4, _room$custom_data, _room$custom_data2, _room$custom_data3, _room$custom_data4, _room$custom_data5;
          const config = {
            messageLimit: room === null || room === void 0 || (_room$config = room.config) === null || _room$config === void 0 ? void 0 : _room$config.messageLimit,
            pollingInterval: room === null || room === void 0 || (_room$config2 = room.config) === null || _room$config2 === void 0 ? void 0 : _room$config2.pollingInterval,
            initialMessageLimit: room === null || room === void 0 || (_room$config3 = room.config) === null || _room$config3 === void 0 ? void 0 : _room$config3.initialMessageLimit,
            userLimit: room === null || room === void 0 || (_room$config4 = room.config) === null || _room$config4 === void 0 ? void 0 : _room$config4.userLimit
          };
          const customData = {
            type: room === null || room === void 0 || (_room$custom_data = room.custom_data) === null || _room$custom_data === void 0 ? void 0 : _room$custom_data.type,
            liveStartBefore: room === null || room === void 0 || (_room$custom_data2 = room.custom_data) === null || _room$custom_data2 === void 0 ? void 0 : _room$custom_data2.liveStartBefore,
            liveEndAfter: room === null || room === void 0 || (_room$custom_data3 = room.custom_data) === null || _room$custom_data3 === void 0 ? void 0 : _room$custom_data3.liveEndAfter,
            skipMessageThreshold: room === null || room === void 0 || (_room$custom_data4 = room.custom_data) === null || _room$custom_data4 === void 0 ? void 0 : _room$custom_data4.skipMessageThreshold,
            appMessageLimit: room === null || room === void 0 || (_room$custom_data5 = room.custom_data) === null || _room$custom_data5 === void 0 ? void 0 : _room$custom_data5.appMessageLimit
          };
          return {
            roomId: room.room_id,
            config: config,
            customData: customData
          };
        });
        return {
          totalCount: res.total_count,
          rooms: rooms
        };
      } catch (e) {
        console.log("getRooms error:", e);
      }
    },
    getRoomToken: async (_parent, _ref5, _ref6) => {
      let {
        roomId
      } = _ref5;
      let {
        dataSources
      } = _ref6;
      try {
        const res = await dataSources.chat.getRoomToken(roomId);
        return {
          token: res.token
        };
      } catch (e) {
        console.log("getRoomToken error:", e);
      }
    },
    getUserToken: async (_parent, _ref7, _ref8) => {
      let {
        roomId,
        userId
      } = _ref7;
      let {
        dataSources
      } = _ref8;
      try {
        const res = await dataSources.chat.getUserToken(roomId, userId);
        return res;
      } catch (e) {
        console.log("getUserToken error:", e);
      }
    }
  },
  Mutation: {
    setChatGuideLineAgreement: async (_parent, _ref9, _ref10) => {
      let {} = _ref9;
      let {
        req,
        res,
        dataSources
      } = _ref10;
      try {
        const agreement = new ChatGuideLineAgreement(req, res);
        console.log("set cookie");
        await agreement.setCookie(true);
        return {
          agreement: true
        };
      } catch (e) {
        console.log("setChatGuideLineAgreement error", e);
        // console.log(JSON.stringify(e.extentions, null, 2));
      }
    },

    createUser: async (_parent, _ref11, _ref12) => {
      let {
        roomId,
        metaId
      } = _ref11;
      let {
        dataSources
      } = _ref12;
      try {
        const res = await dataSources.chat.createUser(roomId, metaId);
        const user = res.user;
        return {
          roomId: user.roomId,
          refId: user.refId,
          id: user.id
        };
      } catch (e) {
        var _body$error;
        console.log("createUser error:", e);
        const body = logicaErrorBody(e);
        const errorCode = body === null || body === void 0 || (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
        if (errorCode) {
          throw new GraphQLError(e.message, {
            extensions: {
              error: {
                code: errorCode
              }
            }
          });
        }
      }
    },
    postChatMessage: async (_parent, _ref13, _ref14) => {
      let {
        roomId,
        userId,
        message,
        refId,
        displayName,
        token
      } = _ref13;
      let {
        dataSources
      } = _ref14;
      try {
        const res = await dataSources.chat.postMessage(roomId, userId, message, refId, displayName, token);
        const msg = res.message;
        return {
          message: msg.data.message,
          sender: msg.data.sender,
          roomId: msg.data.roomId,
          isNGMessage: msg.data.isNGMessage,
          id: msg.data.id
        };
      } catch (e) {
        var _body$error2;
        console.log("postChatMessage error:", e);
        const body = logicaErrorBody(e);
        const errorCode = body === null || body === void 0 || (_body$error2 = body.error) === null || _body$error2 === void 0 ? void 0 : _body$error2.code;
        if (errorCode) {
          throw new GraphQLError(e.message, {
            extensions: {
              error: {
                code: errorCode
              }
            }
          });
        }
      }
    },
    deleteChatMessage: async (_parent, _ref15, _ref16) => {
      let {
        roomId,
        messageId
      } = _ref15;
      let {
        dataSources
      } = _ref16;
      try {
        const res = await dataSources.chat.deleteMessage(roomId, messageId);
        return {
          result: res.result
        };
      } catch (e) {
        var _body$error3;
        console.log("deleteChatMessage error:", e);
        const body = logicaErrorBody(e);
        const errorCode = body === null || body === void 0 || (_body$error3 = body.error) === null || _body$error3 === void 0 ? void 0 : _body$error3.code;
        if (errorCode) {
          throw new GraphQLError(e.message, {
            extensions: {
              error: {
                code: errorCode
              }
            }
          });
        }
      }
    },
    reportChatMessage: async (_parent, _ref17, _ref18) => {
      let {
        roomId,
        messageId,
        reason
      } = _ref17;
      let {
        dataSources
      } = _ref18;
      try {
        const res = await dataSources.chat.reportMessage(roomId, messageId, reason);
        return {
          result: res.result
        };
      } catch (e) {
        var _body$error4;
        console.log("reportChatMessage error:", e);
        const body = logicaErrorBody(e);
        const errorCode = body === null || body === void 0 || (_body$error4 = body.error) === null || _body$error4 === void 0 ? void 0 : _body$error4.code;
        if (errorCode) {
          throw new GraphQLError(e.message, {
            extensions: {
              error: {
                code: errorCode
              }
            }
          });
        }
      }
    }
  }
}, {
  "Query.getChatGuideLineAgreement": [isAuthenticated()],
  "Query.getRooms": [isAuthenticated()],
  "Query.getRoomToken": [isAuthenticated()],
  "Query.getUserToken": [isAuthenticated()],
  "Mutation.setChatGuideLineAgreement": [isAuthenticated()],
  "Mutation.createUser": [isAuthenticated()],
  "Mutation.postChatMessage": [isAuthenticated()],
  "Mutation.deleteChatMessage": [isAuthenticated()],
  "Mutation.reportChatMessage": [isAuthenticated()]
});